var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-container"},[_c('router-link',{attrs:{"to":{ name: 'legacyForm', params: { id: _vm.data.id } }}},[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"d-inline-block form-icon-wrapper",style:({
          background: _vm.style.colorPrimaryButton,
          color: _vm.style.colorPrimaryButtonText
        })},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }